import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { createNewTicketByUploadCsv } from '@/service/ticketService';
import { I18n } from 'aws-amplify';
import Papa from 'papaparse';
import localStorageUtil from '@/common/utils/localStorageUtil';
import crypto from 'crypto-js';

export const onKeyDown = (event, invalidCharArr) => {
    if (Utils.isEmptyArray(invalidCharArr)) {
        return;
    }
    if (invalidCharArr.includes(event.key)) {
        event.preventDefault();
    }
};

export const handleOnPaste = (event, invalidCharArr) => {
    if (Utils.isEmptyArray(invalidCharArr)) {
        return;
    }
    var value = event.clipboardData.getData('text');
    invalidCharArr?.forEach(item => {
        if (value.includes(item)) {
            event.preventDefault();
        }
    });
};

export const parseCSVLine = line => {
    let insideQuotes = false;
    let field = '';
    const fields = [];

    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === ',' && !insideQuotes) {
            fields.push(field);
            field = '';
        } else if (char === '"') {
            insideQuotes = !insideQuotes;
        } else {
            field += char;
        }
    }

    fields.push(field);

    return fields;
};

const parseCSVLines = (contents) => {
    const lines = [];
    let currentLine = '';
    let inQuote = false;
  
    for (let i = 0; i < contents.length; i++) {
      const char = contents[i];
  
      if (char === '"') {
        inQuote = !inQuote;
      }
  
      if ((char === '\n' || char === '\r') && !inQuote) {
        if (char === '\r' && contents[i + 1] === '\n') {
          // Skip the next character if it's '\n' to handle Windows-style line endings
          i++;
        }
        lines.push(currentLine);
        currentLine = '';
      } else {
        currentLine += char;
      }
    }
  
    lines.push(currentLine);
    return lines;
  };

export const handleDragFileOnChange = (
    acceptedFiles,
    setErrorList,
    deleteFile,
    setUploadedFiles,
    setTotalLine,
    setListMappingCsv,
    setCsvContent,
    resetMapping,
    setIsShowPopUpConfirmChangeFile,
    setHandleStatus,
    setIsEdited,
    iconv,
    chardet,
    setCurrentLine,
    setListOptionKnowledge,
    setSelectDeleteMode,
    setSelectDeleteKey,
    setSelectCsvColumnName,
) => {

    if (Utils.isEmptyArray(acceptedFiles) || acceptedFiles?.length > 1) {
        setErrorList(prev => ({ ...prev, uploadFile: I18n.get('KNOWCRMSG002') }));
        deleteFile();
        return;
    }
    
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    let updatedFiles = [];

    for (let file of acceptedFiles) {
        let isGreater50Mb =
            file.size > Constant.UPLOAD_CSV_KNOWLEDGE.MAX_MB_FILE_UPLOAD * 1024 * 1024;
        updatedFiles.push({ name: file.name, size: file.size, file });
        if (isGreater50Mb) {
            deleteFile();
            setErrorList(prev => ({
                ...prev,
                uploadFile: I18n.get('COMMSG021').replace(
                    '{{fileSize}}',
                    Constant.UPLOAD_CSV_KNOWLEDGE.MAX_MB_FILE_UPLOAD
                )
            }));
            setUploadedFiles(updatedFiles);
            setIsShowPopUpConfirmChangeFile({ status: false });
            return;
        }

       
    }

    setUploadedFiles(updatedFiles);

    reader.onload = (e) => {
        const contents = reader.result;
        const fileBuffer = Buffer.from(contents);
  
        // Detect the file encoding
        const detectedEncoding = chardet.detect(fileBuffer);
        // Convert the file content to UTF-8
        const utf8Content = iconv.decode(fileBuffer, detectedEncoding);
        // Parse the CSV using PapaParse
        Papa.parse(utf8Content, {
            skipEmptyLines: true,
          complete: (result) => {
            // Access the parsed data

            const { data } = result;
  
            // Separate the headers and content
            const [headers, ...content] = data;

            // Add headers to each content row
            const contentWithHeaders = content.map((row) =>
            row.reduce((obj, value, index) => {
                obj[index + 1] = value;
                return obj;
            }, {})
            );
            setTotalLine(Number(contentWithHeaders.length) + 1);
            setListMappingCsv(headers);
            setListOptionKnowledge(headers);
            setCsvContent(contentWithHeaders);
          },
          error: (error) => {
            console.error('Error parsing CSV file:', error);
          },
        });
      };

    //clear error upload file
    setErrorList(prev => {
        delete prev.uploadFile;
        return prev;
    });

    setIsEdited(true);
    resetMapping();
    setIsShowPopUpConfirmChangeFile({ status: false });
    setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
    setCurrentLine(Constant.UPLOAD_CSV_KNOWLEDGE.MIN_CURRENT_LINE);

    setSelectDeleteMode({ key: 0, value: I18n.get('KNOWCRLB034') });
    setSelectDeleteKey({});
    setSelectCsvColumnName({});

    // read file contents
    acceptedFiles.forEach(file => reader.readAsArrayBuffer(file));
};

export const createTicketByUploadCsv = async (
    API,
    mappingData,
    corporationId,
    projectId,
    userId,
    formId,
    settingCsv,
    line,
    fileName,
    uploadKey,
    totalLine,
    firstLineUpload
) => {
    if (
        !corporationId ||
        !projectId ||
        !userId ||
        !formId ||
        !line ||
        !fileName ||
        !uploadKey ||
        !totalLine ||
        !firstLineUpload
    ) {
        return;
    }
    let newSettingCsv = {...settingCsv};
    newSettingCsv.password = crypto.AES.encrypt(newSettingCsv.password, Constant.PASSWORD_AES_ENCODE_KEY).toString();

    let sessionId = localStorageUtil.getSessionBrowserId();
    let requestBody = {
        corporationId,
        projectId,
        userId,
        formId,
        settingCsv: JSON.stringify(newSettingCsv),
        mappingData: JSON.stringify(mappingData),
        line,
        fileName,
        uploadKey,
        totalLine,
        firstLineUpload,
        sessionId
    };

    let newTicket = await createNewTicketByUploadCsv(API, requestBody);
    return newTicket;
};

export const checkIsDisabledStartButton = (
    errorList,
    mapping,
    handleStatus,
    selectedTypeImportCsv,
    selectedOptionKnowledgeId,
    selectedUniQueField,
    selectedUniQueCsv
) => {
    if (!Utils.isEmptyObject(errorList)) {
        return true;
    }

    if (
        selectedTypeImportCsv === Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.KNOWLEDGE_ID &&
        Utils.isEmptyString(selectedOptionKnowledgeId)
    ) {
        return true;
    }

    if (
        selectedTypeImportCsv === Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.FIELD_OF_FORM &&
        (Utils.isEmptyString(selectedUniQueCsv) || Utils.isEmptyObject(selectedUniQueField))
    ) {
        return true;
    }

    if (handleStatus === Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START
        || handleStatus === Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS
        || handleStatus === Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE) {
        return true;
    }

    let isChangeMappingDefault = false;

    for (const [key, value] of Object.entries(mapping)) {
        if (value !== Constant.UPLOAD_CSV_KNOWLEDGE.DEFAULT_SELECTED_MAPPING) {
            isChangeMappingDefault = true;
            break;
        }
    }

    if (isChangeMappingDefault && Utils.isEmptyObject(errorList)) {
        return false;
    }

    return true;
};

export const isDisabledAllFieldCsv = (handleStatus) => {
    if(!handleStatus) return true;

    return [
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS,
        Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
    ].includes(handleStatus);
}

export const handleOpenLogScreen = (locationPath) => {
    const win = window.open(locationPath, "_blank");
    win.focus();
}